
import { defineComponent } from 'vue';
import { AppTable, AppCard } from '@/components';
import { componentColumn, TableAction, TableColumn, TableColumnType } from '@/components/table/types';
import { useArenaCycleList } from '@/modules/arena/cycle/model/cycle';
import { RouterLink } from 'vue-router';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.CYCLE.INDEX,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, query, fetchList, ArenaCycleStatus } = useArenaCycleList();

        const columns: TableColumn[] = [
            { type: TableColumnType.Index, label: '#' },
            componentColumn()({
                label: 'Item',
                component: RouterLink,
                propsHandler: row => ({ to: { name: ROUTE_NAME_ARENA.ITEM.DETAIL, params: { id: row.arenaId } } }),
                contentHandler: row => String(row.arenaName)
            }),
            { type: TableColumnType.Text, label: 'Cycle', key: 'id' },
            { type: TableColumnType.DateTime, label: 'Publish Time', key: 'publishTime' },
            { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
            { type: TableColumnType.DateTime, label: 'Close Time', key: 'closeTime' },
            { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
            { type: TableColumnType.DateTime, label: 'Unpublish Time', key: 'unpublishTime' },
            { type: TableColumnType.DateTime, label: 'Archive Time', key: 'archiveTime' },
            { type: TableColumnType.Option, label: 'Status', key: 'status', options: ArenaCycleStatus },
            { type: TableColumnType.Actions, label: 'Actions' }
        ];

        const actions: TableAction[] = [
            {
                props: row => ({
                    icon: 'fa-crown',
                    theme: 'info',
                    tooltip: 'Show ranking',
                    to: { name: ROUTE_NAME_ARENA.CYCLE.RANK, params: { arenaId: row.arenaId, cycleId: row.id } }
                })
            }
        ];

        const table = { columns, actions };

        return { table, list, total, query, fetchList };
    }
});
